import React, { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import StyledButton from '../common/StyledButton';
import css from './App.css';
import Select from 'react-select';
import useStarfishAPI from '../hooks/useStarfishAPI';
import Toast from 'common/Toast';
import ErrorMessage from 'common/ErrorMessage';

const OPTIONS = [
  { value: "", label: "No authentication" },
  { value: "Blackboard", label: "Blackboard" },
  { value: "CAS", label: "CAS" },
  { value: "LDAP", label: "LDAP" },
  { value: "SAML", label: "SAML" },
];

// Endpoint URL
const URL = `../api/deep-link-sso`;

const App = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [configResponse, callConfigAPI] = useStarfishAPI();
  const [saveResponse, callSaveAPI] = useStarfishAPI();

  useEffect(() => {
    callConfigAPI(URL);
  }, []);

  useEffect(() => {
    if ( configResponse.success ) {
      setSelectedOption(OPTIONS.find(({value}) => value === configResponse.data.value));
    }
  }, [configResponse]);

  useEffect(() => {
    if ( saveResponse.success ) {
      setShowToast(true);
      // That's necessary so we make sure sfTenant.getTenantConfig returns the most up-do-date value
      window.location.reload();
    }
  }, [saveResponse.success]);

  const onSubmit = () => {
    if ( saveResponse.pending ) return;
    callSaveAPI(URL, {
      method: "PUT",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        configValue: selectedOption.value
      })
    });
  }

  const getError = () => {
    const errorMessage = configResponse.error || saveResponse.error;
    return errorMessage ? <ErrorMessage message={errorMessage} /> : null;
  };

  return (
    <div className={css['container']}>
      <h3 className="sf-admin-title">Authentication</h3>
      {getError()}
      <div className='x-form-item-label'>Default Authentication Method</div>
      <p>
        Starfish uses the default authentication method for direct links functionality.
        If your institution uses more than one authentication method then you will need to 
        select the one you want to use for direct links.
      </p>
      <label htmlFor="authentication-method-dropdown">
        Please select an authentication method:
      </label>
      <Select
        id="authentication-method-dropdown"
        value={selectedOption} 
        onChange={option => setSelectedOption(option)}
        options={OPTIONS}
        isSearchable={false}
        isLoading={configResponse.pending}
        styles={{
          indicatorSeparator: provided => ({
            ...provided,
            width: 0
          }),
          container: (provided) => ({
            ...provided,
            width: 200,
          }),
          control: (provided, state) => ({
          ...provided,
            border: 0,
            boxShadow: state.isFocused 
              ? "0 0 1px 3px #e6a688" 
              : "0 0 0 1px #878C8C"
          }),
        }}
      />
      <StyledButton 
        className={css['button']}
        aria-disabled={saveResponse.pending} 
        onClick={onSubmit}>
        {saveResponse.pending ? "Saving..." : "Save"}
      </StyledButton>
      {showToast && <Toast 
        message="Authentication method successfully updated." 
        onTimeout={() => setShowToast(false)} 
      />}
    </div>
  );
}

export default hot(module)(App);
